import { render, staticRenderFns } from "./FormItemApiSetting.vue?vue&type=template&id=3c535ab3"
import script from "./FormItemApiSetting.vue?vue&type=script&lang=js"
export * from "./FormItemApiSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports